import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setShowMessage } from "../redux/slices/notificationSlice";
import AlertDeleteModal from "./AlertDelete/AlertDeleteModal";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate, useLocation } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { gettaskAssignListFromDb } from "../redux/slices/gettaskAssignListSlice";
import { Tooltip } from "@mui/material";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import translations from "../assets/locals/translations";
import PersistentDataGrid from "./table/PersistentDataGrid";

const Task = () => {
  const [rowData, setRowData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // PAGINATION STATE - Default 50 rows per page
  const [paginationModel, setPaginationModel] = useState(() => {
    // Try to restore pagination from sessionStorage
    const saved = sessionStorage.getItem('taskPaginationModel');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.warn('Failed to parse saved pagination model');
      }
    }
    return {
      page: 0,
      pageSize: 50,
    };
  });
  const [rowCount, setRowCount] = useState(0); // Total rows in DB
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [type, setType] = useState(null);
  const [statusVisible, setStatusVisible] = useState("none");
  const [statusDropDown, setStatusDropDown] = useState("none");
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [deleteTaskAssignId, setDeleteTaskAssignId] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
  const [showSelectionBox, setShowSelectionBox] = useState({});
  const currentLanguage = useSelector((state) => state.language.language);
  const [taskColumnShowHideModel, setTaskColumnShowHideModel] = useState({});

  const handleHeaderCheckboxClick = () => {
    setSelectAll(!selectAll);
  };

  const handleTaskColumnShowHideChange = (task_newShowHideModel) => {
    setTaskColumnShowHideModel(task_newShowHideModel);
    localStorage.setItem(
      "task_columnShowHide",
      JSON.stringify(task_newShowHideModel)
    );
  };

  useEffect(() => {
    const task_savedShowHideModel = JSON.parse(
      localStorage.getItem("task_columnShowHide")
    );
    if (task_savedShowHideModel) {
      setTaskColumnShowHideModel(task_savedShowHideModel);
    }
  }, []);

  function editTaskModal(data) {
    let type = "edit";
    navigate(`/administration/configuration/task/${type}`, {
      state: { data: data },
    });
  }

  const handleTaskReport = (data) => {
    navigate("/administration/configuration/task/report", {
      state: { data: data },
    });
  };

  const deleteActionCall = (data) => {
    setType("taskassign_delete");
    setDeleteTaskAssignId(data.id);
    setDeleteMessage(
      `Are You Sure You Want To Delete The category '${data.employee}'?`
    );
    setDisplayConfirmationModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  // --- NEW GET TASK LIST WITH PAGINATION ---
  const getTaskList = useCallback(async () => {
    setIsLoading(true);
    // Pass Page and PageSize to Backend
    const url = `${process.env.REACT_APP_NODE_URL}/api/get-task-list?page=${paginationModel.page}&pageSize=${paginationModel.pageSize}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      const response = await Axios.get(url, config);
      if (response.data && response.data.isSuccess) {
        // Format data immediately here
        const formattedData = response.data.result.map((user) => ({
          id: user.id,
          employee: user.employee,
          tasktype: user.tasktype_name,
          task: user.task_name,
          taskcount: user.taskcount,
          startdate: moment(user.startdate).format("DD/MM/YYYY"),
          enddate: moment(user.enddate).format("DD/MM/YYYY"),
          tasktimeperiod: user.period_name,
          EmployeeId: user.EmployeeId,
          taskstatus: user.task_status,
          taskcategory: user.category_name,
          category: user.category,
          taskarea: user.task_area || 'All',
          allocationTypeName: user.allocationTypeName,
          areaIds: user.areaIds,
          checkbox: false // default state
        }));

        setRowData(formattedData);
        setRowCount(response.data.totalCount); // Set total count for pagination
      }
    } catch (error) {
      console.error("Error fetching tasks", error);
    } finally {
      setIsLoading(false);
    }
  }, [paginationModel, location]); // Dependencies: runs when page changes or location changes

  useEffect(() => {
    getTaskList();
  }, [getTaskList]);


  const submitDelete = async () => {
    if (deleteTaskAssignId) {
      const url = `${process.env.REACT_APP_NODE_URL}/api/delete-taskassign/${deleteTaskAssignId}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      try {
        const response = await Axios.get(url, config);
        if (response.data && response.data.isSuccess) {
          dispatch(setShowMessage("Task Deleted"));
          getTaskList();
          setDisplayConfirmationModal(false);
        } else {
          dispatch(setShowMessage("Failed to delete"));
        }
      } catch (error) {
        console.error("Error while deleting task:", error);
      }
    }
  };

  const [newAddTask, setNewAddTask] = useState({
    listTaskStatus: [],
  });

  const checkTabGrant = useCallback((pathAr) => {
    let success = false;
    const rolesArray = localStorage.getItem("rolesArray");
    if (rolesArray) {
      const checkList = rolesArray.split(",");
      pathAr.forEach((element) => {
        if (checkList.includes(element)) {
          success = true;
        }
      });
    }
    return success;
  }, []);

  function taskAssignStatus(id, newStatus) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/update-taskstatus/${id}/${newStatus}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    Axios.get(url, config)
      .then((response) => {
        if (response.data && response.data.result === "success") {
          // Optimistically update or refetch
          getTaskList();
          setStatusDropDown("status-dropdown");
        }
      })
      .catch((error) => {
        console.error("Error while updating task status:", error);
      });
  }

  const getColorClass = (taskstatus) => {
    switch (String(taskstatus)) {
      case "1": return "task-status-1";
      case "2": return "task-status-2";
      case "3": return "task-status-3";
      case "4": return "task-status-4";
      case "5": return "task-status-5";
      default: return "";
    }
  };

  const handleTaskStatus = (rowId) => {
    setShowSelectionBox((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId],
    }));
  };

  const onChangeTaskStatus = (e, id) => {
    const newStatus = e.target.value;
    taskAssignStatus(id, newStatus);
    setShowSelectionBox((prevState) => ({
      ...prevState,
      [id]: false,
    }));

    // Update local state immediately for better UX
    setRowData(prev => prev.map(row =>
      row.id === id ? { ...row, taskstatus: newStatus } : row
    ));
  };

  async function getlisttaskStatus() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/get-taskstatus-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        setNewAddTask((prev) => ({
          ...prev,
          ["listTaskStatus"]: response.data.result,
        }));
      }
    });
  }

  useEffect(() => {
    getlisttaskStatus();
    gettaskAssignListFromDb();
  }, []);

  // Persist pagination model to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('taskPaginationModel', JSON.stringify(paginationModel));
  }, [paginationModel]);

  // Update rows when Select All Checkbox is clicked
  useEffect(() => {
    if (rowData.length > 0) {
      setRowData(prev => prev.map(item => ({ ...item, checkbox: selectAll })));
    }
  }, [selectAll]);

  const handleChildCheckboxClick = (itemId) => {
    setRowData(prev => prev.map((row) => {
      if (row.id === itemId) {
        return { ...row, checkbox: !row.checkbox };
      }
      return row;
    }));
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const columns = [
    {
      field: "id",
      headerName: (
        <Checkbox
          {...label}
          checked={selectAll}
          onClick={handleHeaderCheckboxClick}
        />
      ),
      minWidth: 90,
      renderCell: (params) => (
        <Checkbox
          {...label}
          checked={params.row.checkbox || false}
          onClick={() => handleChildCheckboxClick(params.row.id)}
        />
      ),
    },
    {
      field: "employee",
      headerName: translations[currentLanguage].employee,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <div className="myBtnForEdit" onClick={() => editTaskModal(params.row)}>
          {params.row.employee || "-"}
        </div>
      ),
    },
    { field: "tasktype", headerName: translations[currentLanguage].tasktype, minWidth: 200, flex: 1 },
    { field: "task", headerName: translations[currentLanguage].task, minWidth: 200, flex: 1 },
    { field: "taskcategory", headerName: translations[currentLanguage].category, minWidth: 200, flex: 1 },
    { field: "allocationTypeName", headerName: translations[currentLanguage].allocationtype, minWidth: 300, flex: 1 },
    { field: "taskarea", headerName: translations[currentLanguage].taskarea, minWidth: 300, flex: 1 },
    {
      field: "taskstatus",
      headerName: translations[currentLanguage].taskstatus,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const taskstatus = params.row.taskstatus || "";
        const colorClass = getColorClass(taskstatus);
        const rowId = params.row.id;

        return (
          <div className="">
            {showSelectionBox[rowId] ? (
              <select
                onChange={(e) => onChangeTaskStatus(e, params.row.id)}
                className={`${statusDropDown} myInput custom-select px-4 rounded-pill`}
                name="taskstatus"
                value={params.row.taskstatus}
              >
                {newAddTask.listTaskStatus.map((i) => (
                  <option key={i.id} value={i.id} className="myLabel">
                    {i.task_status}
                  </option>
                ))}
              </select>
            ) : (
              <p
                className={`${statusVisible} ${colorClass} cursorpointer rounded-pill px-4`}
                onClick={() => handleTaskStatus(rowId)}
              >
                {taskstatus == 1 && "New"}
                {taskstatus == 2 && "In Progress"}
                {taskstatus == 3 && "On Hold"}
                {taskstatus == 4 && "Discard"}
                {taskstatus == 5 && "Done"}
              </p>
            )}
          </div>
        );
      },
    },
    { field: "taskcount", headerName: translations[currentLanguage].taskcount, minWidth: 200, flex: 1 },
    { field: "startdate", headerName: translations[currentLanguage].startd, minWidth: 200, flex: 1 },
    { field: "enddate", headerName: translations[currentLanguage].endd, minWidth: 200, flex: 1 },
    { field: "tasktimeperiod", headerName: translations[currentLanguage].tasktimep, minWidth: 200, flex: 1 },
    {
      field: "menu",
      headerName: <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />,
      className: "bg-dark",
      sortable: false,
      filterable: false,
      headerAlign: "right",
      align: "right",
      disableColumnMenu: true,
      width: 130,
      position: "sticky",
      renderCell: (params) => (
        <div className="d-flex justify-content-center dotHoverempicon ">
          <FontAwesomeIcon icon={faEllipsisV} />
          <div className="expandDiv">
            <Tooltip title={translations[currentLanguage].edit}>
              <button className="myActionBtn m-1" onClick={() => editTaskModal(params.row)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title={translations[currentLanguage].delete}>
              <button onClick={() => deleteActionCall(params.row)} className="myActionBtn m-1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                </svg>
              </button>
            </Tooltip>
            {checkTabGrant(["assign-task"]) && (
              <Tooltip title={"Task Report"}>
                <button onClick={() => handleTaskReport(params.row)} className="myActionBtn m-1">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M4 0h6l4 4v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm6 1.5V5h3.5L10 1.5zM3 2v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h-4V2H4a1 1 0 0 0-1 1z" />
                  </svg>
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      ),
    },
  ];

  const redirectModal = () => {
    navigate(-1);
  };

  return (
    <div className="bg-white rounded p-3">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <h4 className="">Task List</h4>
        <div className="d-flex align-items-center">
          {checkTabGrant(["assign-task"]) && (
            <Tooltip title={"Assign Task"}>
              <div
                onClick={() => navigate(`/administration/configuration/task/${"add"}`)}
                className="d-flex align-items-center cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
              </div>
            </Tooltip>
          )}

          <Button
            variant="btn btn-warning"
            style={{
              width: "70px",
              height: "35px",
              fontSize: "14px",
              borderRadius: "20px",
              marginLeft: "10px",
            }}
            onClick={redirectModal}
          >
            {translations[currentLanguage].back}
          </Button>
        </div>
      </div>

      <div className="tableMenuHover" style={{ height: "85vh", width: "100%" }}>
        <PersistentDataGrid
          rows={rowData}
          columns={columns}
          // Server Side Pagination Props
          rowCount={rowCount}
          loading={isLoading}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          // End Server Side Props

          columnVisibilityModel={taskColumnShowHideModel}
          onColumnVisibilityModelChange={handleTaskColumnShowHideChange}
          getRowId={(params) => params.id}
          className="rounded"
          style={{
            fontFamily: "Poppins",
            padding: 5,
            backgroundColor: "white",
          }}
          components={{
            Toolbar: GridToolbar,
            NoRowsOverlay: () => (
              <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span>There is no Users with current branch</span>
              </div>
            ),
          }}
          componentsProps={{
            toolbar: {
              position: "right",
              style: { fontFamily: "Poppins", alignSelf: "end" },
            },
          }}
          rowSelection={false}
          autoPageSize={false}
        />
      </div>
      <AlertDeleteModal
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={deleteTaskAssignId}
        message={deleteMessage}
      />
    </div>
  );
};
export default Task;